<template>
  <van-sticky :offset-top="headerHeight" :class="{ 'not-sticky': isRecommend }" :style="`height: ${menusHeight}px`">
    <div class="home-tab-wrapper" ref="menuRef">
      <div class="tab-menus-wrapper">
        <van-tabs
          ref="mainMenuRef"
          class="home-game-tab"
          v-model:active="activeHomeMainMenuTab"
          :line-height="0"
          shrink
          @change="onTabChange"
          @click-tab="tabClick"
        >
          <van-tab v-for="item in homeMainTabMenus" :key="item.key" :name="item.key">
            <template #title>
              <div class="home-tab-item">
                <img :src="item.logo || `/images/game/${item.icon}.png`" alt="" />
                <span class="tab-name">{{ mb_t(item.name) }}</span>
              </div>
            </template>
          </van-tab>
        </van-tabs>
        <template v-if="isShowSubGameTabMenus">
          <sub-game-category-menu :menus="activeHomeSubTabMenus" @on-sub-change="onSubChange" @click-tab="tabClick" />
        </template>
        <!--      <span>{{ activeHomeMainMenuTab }}-{{ activeHomeSubMenuTab }}-{{ activeHomeChildMenuTab }}</span>-->
      </div>
    </div>
  </van-sticky>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import { getTenantName } from '@/plugins/public_utils';
import { storeToRefs, useAppStore, useGameStore, useHot } from '@star/stores';
import { handleServerGameImg } from '@/plugins/game';
import { defaultHomeGameTabMenusMap, GameChildTypesEnum, GameMainTypesEnum, gameMainTypesMap } from '@star/constants';
import { useRoute, useRouter } from 'vue-router';
import { filter, find, get, includes, map, pickBy, toNumber } from 'lodash-es';
import SubGameCategoryMenu from './SubGameCategoryMenu.vue';
import { mb_t } from '@star/languages';
import { useElementSize, useWindowScroll } from '@vueuse/core';
import { emitter, EventEnum } from '@star/utils';

const { hotData } = useHot();
const { isLogin } = hotData;

type Props = {
  topHeight: number;
};
const props = defineProps<Props>();

const gameStore = useGameStore();
const {
  gameMainClassList,
  gameBigClass,
  activeHomeMainMenuTab,
  activeHomeSubMenuTab,
  activeHomeChildMenuTab,
  lotteryThird,
} = storeToRefs(gameStore);
const { template, headerHeight, isPageLoading } = storeToRefs(useAppStore());
const route = useRoute();
const router = useRouter();
// const { t } = useI18n();
const { y } = useWindowScroll();
const recommendTabScrollHeight = ref<number>(0);
const menuRef = ref<any>(null);
const mainMenuRef = ref<any>(null);
const bigTypeImgs = ref({});
const { height: menusHeight } = useElementSize(menuRef);

// 是否推荐菜单
const isRecommend = computed(() => {
  return toNumber(activeHomeMainMenuTab.value) === GameMainTypesEnum.RECOMMEND;
});

const homeMainTabMenus = computed(() => {
  const defaultMenus = defaultHomeGameTabMenusMap[template.value] || [];
  // console.log('gameMainClassList.value', gameMainClassList.value, gameBigClass.value);
  let _gameMenu = map(gameMainClassList.value, item => {
    const typeName = gameMainTypesMap[item.type as GameMainTypesEnum];
    // console.log(item, typeName, 'item.type', bigTypeImgs.value);
    // console.log(typeName, 'typeName 00000000000');
    // console.log(gameBigClass.value?.[typeName], typeName, 'item.children');

    let _children: any = [];
    if (typeName === 'lottery') {
      const _thirdLottery: any[] = [];
      _children = [
        // 平台彩
        {
          name: `${getTenantName()}`,
          key: `platform`,
          darkImgSrc: `/images/game/${typeName}/dark_platform.png`,
          lightImgSrc: `/images/game/${typeName}/light_platform.png`,
          colorImgSrc: `/images/game/${typeName}/color_platform.png`,
        },
        // 3方彩
        ..._thirdLottery,
      ];
    } else {
      _children = map(gameBigClass.value?.[typeName], it => {
        return {
          name: mb_t(it.play_cname),
          key: `${it.play_id}`,
          play_sort: it.play_sort,
          darkImgSrc: `/images/game/${typeName}/dark_${it.play_id}.png`,
          lightImgSrc: `/images/game/${typeName}/light_${it.play_id}.png`,
          colorImgSrc: handleServerGameImg(it.logo3_img_url) || `/images/game/${typeName}/color_${it.play_id}.png`,
        };
      });
    }
    return {
      name: mb_t(item.play_name),
      key: `${item.type}`,
      icon: typeName,
      logo: bigTypeImgs.value[item.play_name],
      // children: getSubGameTabMenus(item.type),
      children: _children,
    };
  });

  let typeList = [GameMainTypesEnum.RECOMMEND];

  // 未登录状态开启试玩
  if (!isLogin.value) {
    typeList.push(GameMainTypesEnum.TRIAL);
  } else {
    // 已经登录过滤试玩
    _gameMenu = _gameMenu.filter(e => String(e.key) !== String(GameMainTypesEnum.TRIAL));
  }

  console.log(_gameMenu, '_gameMenu');

  return map(
    [
      ...filter(defaultMenus, item => typeList.includes(item.key)),
      ..._gameMenu,
      ...filter(defaultMenus, item => [GameMainTypesEnum.COLLECT, GameMainTypesEnum.RECENT].includes(item.key)),
    ],
    item => ({
      ...item,
      key: `${item.key}`,
    })
  );
});

const activeHomeSubTabMenus = computed(() => {
  const result = get(
    find(homeMainTabMenus.value, item => item.key === activeHomeMainMenuTab.value),
    'children',
    []
  ).sort((a, b) => a.play_sort - b.play_sort);
  console.log('resultresult', result, homeMainTabMenus.value, activeHomeMainMenuTab.value);
  return hasSubGameTabMenus.value
    ? [
        {
          name: mb_t('热门'),
          key: `${GameMainTypesEnum.HOT_GAME + toNumber(activeHomeMainMenuTab.value)}`,
          // key: `${GameMainTypesEnum.HOT}`,
          colorImgSrc: `/images/game/color-hot.png`,
        },
        ...result,
      ]
    : [];
});

// 是否显示二级以下菜单
const isShowSubGameTabMenus = computed(() => {
  return !includes(
    [GameMainTypesEnum.RECOMMEND, GameMainTypesEnum.COLLECT, GameMainTypesEnum.RECENT],
    toNumber(activeHomeMainMenuTab.value)
  );
});

// 当前一级菜单下是否有二级菜单
const hasSubGameTabMenus = computed(() => {
  // return gameBigClass.value?.[gameMainTypesMap[activeHomeMainMenuTab.value]]?.length > 0;
  return includes(
    [GameMainTypesEnum.CHESS, GameMainTypesEnum.ELECTRONIC, GameMainTypesEnum.FISHING, GameMainTypesEnum.BLOCK_THIRD],
    toNumber(activeHomeMainMenuTab.value)
  );
});

const onTabChange = (key?: GameMainTypesEnum) => {
  // 进入试玩游戏页面
  if (toNumber(key) === GameMainTypesEnum.TRIAL) {
    return router.push('/trial');
  }

  if (route.name !== 'home') return;
  console.log(key, ' ----- onTabChange');
  gameStore.setActiveHomeMainMenuTab(key);
  gameStore.setActiveHomeChildMenuTab(isShowSubGameTabMenus.value ? GameChildTypesEnum.ALL : '');
  router.push({
    name: 'home',
    params: { mainType: key ?? '', subType: activeHomeSubTabMenus.value?.[0]?.key || '' },
    query: pickBy(
      {
        ...route.query,
        childType: isShowSubGameTabMenus.value ? GameChildTypesEnum.ALL : '',
      },
      val => !!val
    ),
  });
  emitter.emit(EventEnum.HOME_SEARCH_GAME_RESET);
};

const onSubChange = (key?: string) => {
  if (route.name !== 'home') return;
  // console.log(key, '--------onSubChange');
  gameStore.setActiveHomeSubMenuTab(key);
  gameStore.setActiveHomeChildMenuTab(GameChildTypesEnum.ALL);
  router.push({
    name: 'home',
    params: { mainType: activeHomeMainMenuTab.value ?? '', subType: key },
    query: pickBy({ ...route.query, childType: GameChildTypesEnum.ALL }, val => !!val),
  });
};

const tabClick = (data?: any) => {
  pageScrollTop(data?.name);
};

const pageScrollTop = (mainType?: GameMainTypesEnum) => {
  setTimeout(() => {
    const key = toNumber(mainType || activeHomeMainMenuTab.value);
    const top =
      key === GameMainTypesEnum.RECOMMEND
        ? recommendTabScrollHeight.value > props.topHeight
          ? recommendTabScrollHeight.value
          : props.topHeight + 1
        : props.topHeight + 1;
    console.log(top, '0000000000000000000');
    window.scrollTo({ top: props.topHeight + 1, behavior: 'smooth' });
  }, 100);
};

const tabMenuScroll = () => {
  const tab_offsetLeft = mainMenuRef.value?.$el?.querySelector('.van-tab--active')?.offsetLeft;
  const tab_offsetWidth = mainMenuRef.value?.$el?.querySelector('.van-tab--active')?.offsetWidth;
  const nav_offsetWidth = mainMenuRef.value?.$el?.querySelector('.van-tabs__nav')?.offsetWidth;
  const left = tab_offsetLeft - (nav_offsetWidth - tab_offsetWidth) / 2;
  mainMenuRef.value?.$el?.querySelector?.('.van-tabs__nav')?.scrollTo?.({
    left: left ?? 0,
    behavior: 'smooth',
  });
};

watch(
  () => activeHomeMainMenuTab.value,
  value => {
    tabMenuScroll();
    pageScrollTop(activeHomeMainMenuTab.value);
  },
  {
    immediate: true,
  }
);

watch(
  () => route.params?.mainType,
  value => {
    if (route.name !== 'home') return;
    console.log(value, 'route.params.mainType');
    gameStore.setActiveHomeMainMenuTab(value as any);
    gameStore.setActiveHomeChildMenuTab(isShowSubGameTabMenus.value ? GameChildTypesEnum.ALL : '');
  },
  {
    immediate: true,
  }
);

watch(
  () => route.params?.subType,
  value => {
    if (route.name !== 'home') return;
    // console.log(value, 'route.query?.subType');
    gameStore.setActiveHomeSubMenuTab(value as string);
    gameStore.setActiveHomeChildMenuTab(GameChildTypesEnum.ALL);
  },
  {
    immediate: true,
  }
);

watch(
  () => route.query?.childType,
  value => {
    if (route.name !== 'home') return;
    console.log(value, 'route.query?.childType');
    gameStore.setActiveHomeChildMenuTab(value as string);
  },
  {
    immediate: true,
  }
);

watch(
  () => y.value,
  value => {
    if (isRecommend.value) {
      recommendTabScrollHeight.value = value;
    }
  }
);

watch(
  () => isPageLoading.value,
  async (value, oldValue) => {
    if (!value && oldValue) {
      tabMenuScroll();
      if (!isRecommend.value) {
        pageScrollTop();
      }
    }
  }
);

emitter.on(EventEnum.HOME_PAGE_SCROLL, (mainType?: GameMainTypesEnum) => {
  pageScrollTop(mainType);
});

onMounted(async () => {
  // if (isSpecialTenant(17, 5)) {
  //   setTimeout(() => {
  //     changeMenuTab(GameMainTypesEnum.ELECTRONIC);
  //   });
  // }
  // if (route.query?.key) {
  //   setTimeout(() => {
  //     changeMenuTab(route.query.key + '');
  //   }, 1000);
  // }
  const res = await gameStore.getGamesBigTypeData();
  // todo 暂时以play_cname 作为比对,后面优化,暂时没数据能匹配
  const _imgMap = {};
  res.forEach((item: any) => {
    _imgMap[item.play_name] = item.logo_url1;
  });
  bigTypeImgs.value = _imgMap;
});
</script>

<style lang="less" scoped>
.home-tab-wrapper {
  padding: 0 33px;
  background-color: var(--theme-backgroud-color);

  .tab-menus-wrapper {
    padding-top: 8px;
    // padding-bottom: 24px;
    .home-game-tab {
      border-bottom: 1px solid #efefef;
      margin-left: -30px;
      width: calc(100% + 60px);
    }
  }

  .home-tab-item {
    height: 163px;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 10px 40px;
    white-space: nowrap;

    img {
      height: 69px;
    }

    .svg-icon {
      color: var(--van-tab-text-color);
    }

    .tab-name {
      color: var(--van-tab-text-color);
      font-size: 42px;
      font-weight: 400;
    }
  }

  :deep(.van-tabs__wrap) {
    height: 163px;

    .van-tabs__nav {
      padding: 0;
    }

    .van-tab {
      padding: 0;
      line-height: normal;

      + .van-tab {
        margin-left: 20px;
      }

      &.van-tab--active {
        .home-tab-item {
          background: linear-gradient(360deg, rgb(16 200 227 / 20%) 0%, rgb(255 255 255 / 0%) 100%);
          position: relative;

          .tab-name {
            color: var(--theme-btn-primary-color);
          }

          &::after {
            width: 100%;
            height: 6px;
            background: var(--theme-btn-primary-background);
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
      }
    }

    .van-tabs__line {
      display: none !important;
    }
  }
}

//.header-sticky {
//height: auto !important;
//}

//:deep(.van-sticky) {
//  &.van-sticky--fixed {
//    height: auto !important;
//  }
//}
</style>
